const { isProduction } = require('../helpers/env/checkEnvironmentType');
const sharedConfig = require('./shared');
const production = require('./production');
const stage = require('./stage');

module.exports = {
  ...isProduction() ? production : stage,
  ...sharedConfig,
};
